import {useState} from "react";

import {PermitApplicationService} from "permitapplication/service";
import {useNavigateWithReload} from "base/navigation/hooks";

import {TreeForm} from "tree/presentational/form";
import {AddNewInlineItemButton, AddNewInlineItemFormBox} from "base/shared/components";
import {useErrors} from "base/error/provider/ErrorProvider";

const CreateTreeDataContent = ({permit, displayFees}) => {
    const navigate = useNavigateWithReload();
    const {handleErrors} = useErrors();

    const [mode, setMode] = useState("button");

    const handleFormSubmit = tree => {
        PermitApplicationService.createTree(permit?.id, tree)
            .then(createdTree => {
                setMode("button");
                navigate("", true);
            })
            .catch(error => {
                handleErrors(error);
            });
    };

    return mode === "button" ? (
        <AddNewInlineItemButton
            onClick={() => {
                setMode("create");
            }}
            label="Acrescentar árvore"
        />
    ) : mode === "create" ? (
        <AddNewInlineItemFormBox label="Acrescentar árvore">
            <TreeForm
                permit={permit}
                displayFees={displayFees}
                onSubmit={handleFormSubmit}
                onCancel={() => {
                    setMode("button");
                }}
            />
        </AddNewInlineItemFormBox>
    ) : null;
};

export default CreateTreeDataContent;
